
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("contact/input_function",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"labels.type",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":32}}})) != null ? stack1 : "")
    + " <input type=\"text\" name=\"function\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"function") : depth0), depth0))
    + "\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"new_contact.type_placeholder",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":104},"end":{"line":1,"column":145}}})) != null ? stack1 : "")
    + "\" maxlength=\"45\"/></label>";
},"useData":true});
export default TPL;